import React, { Component } from 'react';
import { Button, Select, InputNumber, Modal, Radio, Upload, message, Icon, Tooltip, Table } from 'antd';
import API_URL from "../../../common/url";
import $, { xToken } from '../../../common/AjaxRequest';
import '../css/style.less';
import TableC from '../../basicElement/TableC';
import SearchRetrieve from '../../common/SearchRetrieve.new'
const RadioGroup = Radio.Group;
const { Option } = Select;

// GP 计算默认表格数据 有盲态、非盲态
const tableDataDefautltByGpBoth = [{
        id: 1,
        index: 1,
        name: '建议标访报价',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 2,
        name: '建议单例价格（不含税）/人民币（盲态）',
        key: 'visitContractUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 3,
        name: '建议合同总价（不含税）/人民币（盲态）',
        key: 'visitContractTotalAmountNoTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 4,
        name: '建议合同总价（含税6%）/人民币（盲态）',
        key: 'visitContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 5,
        name: '建议标准访视单价（不含税）/人民币',
        key: 'visitStandardAmount',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 6,
        name: '建议FTE报价',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 7,
        name: '建议单例价格（不含税）/人民币（盲态）',
        key: 'fteContractUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 8,
        name: '建议合同总价（不含税）/人民币（盲态）',
        key: 'fteContractTotalAmountNoTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 9,
        name: '建议合同总价（含税6%）/人民币（盲态）',
        key: 'fteContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 10,
        name: '建议FTE单价单价（不含税）/人民币',
        key: 'fteStandardAmount',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 11,
        name: '非盲服务报价（只做FTE制）',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 12,
        name: '建议单例价格（不含税）/人民币（非盲）',
        key: 'nonBindFteContractUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 13,
        name: '建议合同总价（不含税）/人民币（非盲）',
        key: 'nonBindFteContractTotalAmountNoTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 14,
        name: '建议合同总价（含税6%）/人民币（非盲）',
        key: 'nonBindFteContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    }]
// GP 计算默认表格数据 有盲态、非盲态， 建议底价方式是FTE制，不展示建议标访报价
const tableDataDefautltByGpBothFTE = [
    {
        id: 1,
        name: '建议FTE报价',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 2,
        name: '建议单例价格（不含税）/人民币（盲态）',
        key: 'fteContractUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 3,
        name: '建议合同总价（不含税）/人民币（盲态）',
        key: 'fteContractTotalAmountNoTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 4,
        name: '建议合同总价（含税6%）/人民币（盲态）',
        key: 'fteContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 5,
        name: '建议FTE单价单价（不含税）/人民币',
        key: 'fteStandardAmount',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 6,
        name: '非盲服务报价（只做FTE制）',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 7,
        name: '建议单例价格（不含税）/人民币（非盲）',
        key: 'nonBindFteContractUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 8,
        name: '建议合同总价（不含税）/人民币（非盲）',
        key: 'nonBindFteContractTotalAmountNoTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 9,
        name: '建议合同总价（含税6%）/人民币（非盲）',
        key: 'nonBindFteContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    }]
// GP 计算默认表格数据 只有盲态或只有非盲态
const tableDataDefautltByGp = [{
        id: 1,
        index: 1,
        name: '建议标访报价',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 2,
        name: '建议单例价格（不含税）/人民币',
        key: 'visitContractUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 3,
        name: '建议合同总价（不含税）/人民币',
        key: 'visitContractTotalAmountNoTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 4,
        name: '建议合同总价（含税6%）/人民币',
        key: 'visitContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 5,
        name: '建议标准访视单价（不含税）/人民币',
        key: 'visitStandardAmount',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 6,
        name: '建议FTE报价',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 7,
        name: '建议单例价格（不含税）/人民币',
        key: 'fteContractUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 8,
        name: '建议合同总价（不含税）/人民币',
        key: 'fteContractTotalAmountNoTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 9,
        name: '建议合同总价（含税6%）/人民币',
        key: 'fteContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 10,
        name: '建议FTE单价单价（不含税）/人民币',
        key: 'fteStandardAmount',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    }]
// GP 计算默认表格数据 只有盲态或只有非盲态， 建议底价方式是FTE制，不展示建议标访报价
const tableDataDefautltByGpFTE = [
    {
        id: 1,
        name: '建议FTE报价',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 2,
        name: '建议单例价格（不含税）/人民币',
        key: 'fteContractUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 3,
        name: '建议合同总价（不含税）/人民币',
        key: 'fteContractTotalAmountNoTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 4,
        name: '建议合同总价（含税6%）/人民币',
        key: 'fteContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 5,
        name: '建议FTE单价单价（不含税）/人民币',
        key: 'fteStandardAmount',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    }]
// 总价 计算默认表格数据 有盲态、非盲态
const tableDataDefautltByPriceBoth = [{
        id: 1,
        index: 1,
        name: '建议标访报价',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 2,
        name: '建议单例价格（不含税）/人民币（盲态）',
        key: 'visitUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 3,
        name: '建议合同总价（含税6%）/人民币（盲态）',
        key: 'visitContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 4,
        name: '建议标准访视单价（不含税）/人民币',
        key: 'visitStandardAmount',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 5,
        name: '建议GP值（%）',
        key: 'visitGp',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 6,
        name: '建议FTE报价',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 7,
        name: '建议单例价格（不含税）/人民币（盲态）',
        key: 'fteUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 8,
        name: '建议合同总价（含税6%）/人民币（盲态）',
        key: 'fteContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 9,
        name: '建议FTE单价单价（不含税）/人民币',
        key: 'fteStandardAmount',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 10,
        name: '建议GP值（%）',
        key: 'fteGp',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 11,
        name: '非盲服务报价（只做FTE制）',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 12,
        name: '建议单例价格（不含税）/人民币（非盲）',
        key: 'nonBindUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 13,
        name: '建议合同总价（不含税）/人民币（非盲）',
        key: 'nonBindTotalPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 14,
        name: '建议合同总价（含税6%）/人民币（非盲）',
        key: 'nonBindcontractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    }]
// 总价 计算默认表格数据 有盲态、非盲态，建议底价方式是FTE制，不展示建议标访报价
const tableDataDefautltByPriceBothFTE = [
    {
        id: 1,
        name: '建议FTE报价',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 2,
        name: '建议单例价格（不含税）/人民币（盲态）',
        key: 'fteUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 3,
        name: '建议合同总价（含税6%）/人民币（盲态）',
        key: 'fteContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 4,
        name: '建议FTE单价单价（不含税）/人民币',
        key: 'fteStandardAmount',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 5,
        name: '建议GP值（%）',
        key: 'fteGp',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 6,
        name: '非盲服务报价（只做FTE制）',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 7,
        name: '建议单例价格（不含税）/人民币（非盲）',
        key: 'nonBindUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 8,
        name: '建议合同总价（不含税）/人民币（非盲）',
        key: 'nonBindTotalPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 9,
        name: '建议合同总价（含税6%）/人民币（非盲）',
        key: 'nonBindcontractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    }]
// 总价 计算默认表格数据 只有盲态或只有非盲态，
const tableDataDefautltByPrice = [{
        id: 1,
        index: 1,
        name: '建议标访报价',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 2,
        name: '建议单例价格（不含税）/人民币',
        key: 'visitUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 3,
        name: '建议合同总价（含税6%）/人民币',
        key: 'visitContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 4,
        name: '建议标准访视单价（不含税）/人民币',
        key: 'visitStandardAmount',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 5,
        name: '建议GP值（%）',
        key: 'visitGp',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 6,
        name: '建议FTE报价',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 7,
        name: '建议单例价格（不含税）/人民币',
        key: 'fteUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 8,
        name: '建议合同总价（含税6%）/人民币',
        key: 'fteContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 9,
        name: '建议FTE单价单价（不含税）/人民币',
        key: 'fteStandardAmount',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 10,
        name: '建议GP值（%）',
        key: 'fteGp',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    }]
// 总价 计算默认表格数据 只有盲态或只有非盲态，建议底价方式是FTE制，不展示建议标访报价
const tableDataDefautltByPriceFTE = [
    {
        id: 1,
        name: '建议FTE报价',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 2,
        name: '建议单例价格（不含税）/人民币',
        key: 'fteUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 3,
        name: '建议合同总价（含税6%）/人民币',
        key: 'fteContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 4,
        name: '建议FTE单价单价（不含税）/人民币',
        key: 'fteStandardAmount',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 5,
        name: '建议GP值（%）',
        key: 'fteGp',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    }]
class GPCalculateLogModal extends Component {
    state = {
        gpCalculateLog: {},
        serveFeeType: '',
        columns: [{ title: '', dataIndex: 'name', key: 'name', width: 260 }],
        tableData: [],
        count: 0,
        visible: false,
        loading: false,
    }
    // 打开GP测算弹窗
    show = (record) => {
        this.setState({
            visible: true,
        }, async () => {
            try {
                // 等待两个异步方法都完成
                await Promise.all([
                    this.loadQueryGpCalculateLog(record.evaluateRecordOperateLogId),
                    this.queryServeFeeType(record.evaluateRecordId)
                ]);
                this.rebuildTable()
            } catch (error) {
                // console.error('数据加载失败:', error);
                // message.error('数据加载失败，请重试');
            }
        });
    }
    // 获取评估参数
    loadQueryGpCalculateLog = (evaluateRecordOperateLogId) => {
        return new Promise((resolve, reject) => {
            let data ={
                evaluateRecordOperateLogId,
            }
            const options = {
                method: "POST",
                url: API_URL.evaluate.queryGpCalculateLog,
                data,
                dataType: "json",
                doneResult: (res) => {
                    this.setState({
                        gpCalculateLog: res.data || {},
                    }, () => resolve(res));
                },
                failResult: (err) => {
                    reject(err);
                },
            }
            $.sendRequest(options);
        });
    }

    // 获取项目服务内容 （盲态、非盲态、盲态和非盲态）
    queryServeFeeType = (evaluateRecordId) => {
        return new Promise((resolve, reject) => {
            const options = {
                method: "POST",
                url: API_URL.evaluate.queryServeFeeType,
                data: { evaluateRecordId },
                dataType: "json",
                doneResult: (res) => {
                    const { serveFeeType } = res;
                    this.setState({
                        serveFeeType,
                    }, () => resolve(res));
                },
                failResult: (err) => {
                    reject(err);
                },
            };
            $.sendRequest(options);
        });
    }

    hide = () => {
        this.setState({
            gpCalculateLog: {},
            serveFeeType: '',
            columns: [{
                title: '',
                dataIndex: 'name',
                key: 'name',
                width: 260,
            }],
            tableData: [],
            count: 0,
            visible: false,
            loading: false,
        });
    }

    // 【核心重构】全量重绘表格方法
    rebuildTable = () => {
        const { gpCalculateLog, serveFeeType } = this.state;
        const { gpStatus, evaluateCalcGpDetails, evaluateCalcGpPriceDetails, basePriceStatus } = gpCalculateLog || {};

        const isBindAndNonBind = serveFeeType === "NON_BIND,BIND";
        
        // 1. 确定数据源
        const dataSource = gpStatus === 'GP' ? evaluateCalcGpDetails : evaluateCalcGpPriceDetails;
        
        // 2. 初始化列头
        let newColumns = [{ title: '', dataIndex: 'name', key: 'name', width: 260 }];
        
        // 3. 确定并深拷贝表格模版
        let template;
        if (gpStatus === 'GP') {
            if (isBindAndNonBind) {
                template = basePriceStatus === 'FTE' ? tableDataDefautltByGpBothFTE : tableDataDefautltByGpBoth;
            } else {
                template = basePriceStatus === 'FTE' ? tableDataDefautltByGpFTE : tableDataDefautltByGp;
            }
        } else {
            if (isBindAndNonBind) {
                template = basePriceStatus === 'FTE' ? tableDataDefautltByPriceBothFTE : tableDataDefautltByPriceBoth;
            } else {
                template = basePriceStatus === 'FTE' ? tableDataDefautltByPriceFTE : tableDataDefautltByPrice;
            }
        }
        let newTableData = JSON.parse(JSON.stringify(template));

        // 4. 根据数据源动态构建每一列
        dataSource.forEach((dataItem, idx) => {
            const currentCount = idx + 1;
            const dataIndex = 'value' + currentCount;

            // 构建标题
            let title;
            if (gpStatus === 'GP') {
                title = `GP%=${dataItem.gpValue}%`;
            } else {
                if (serveFeeType === "BIND") {
                    title = `总价=${(dataItem.bindPrice || 0).toLocaleString('zh-CN', { minimumFractionDigits: 2 })}`;
                } else if (serveFeeType === "NON_BIND") {
                    title = `总价=${(dataItem.noBindPrice || 0).toLocaleString('zh-CN', { minimumFractionDigits: 2 })}`;
                } else {
                    const total = Number(((dataItem.bindPrice || 0) + (dataItem.noBindPrice || 0)).toFixed(2));
                    title = `总价=${total.toLocaleString('zh-CN', { minimumFractionDigits: 2 })}`;
                }
            }

            // 添加列定义
            newColumns.push({
                title,
                dataIndex,
                key: dataIndex,
                width: 120,
                className: 'text-center',
                render: (text, record) => {
                    if (text === undefined || text === '' || text === '-') return text || 0;
                    if (record.name && record.name.includes('人民币')) {
                        const num = Number(text);
                        // 如果数值是整数，则不显示小数位；否则显示两位小数
                        if (Number.isInteger(num)) {
                            return num.toLocaleString('zh-CN');
                        } else {
                            return num.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                        }
                    }
                    if (record.name && record.name.includes('（%）')) {
                        return text + '%';
                    }
                    return text;
                }
            });

            // 填充数据到模版行中
            newTableData.forEach(row => {
                if (row.key && dataItem[row.key] !== undefined) {
                    row[dataIndex] = dataItem[row.key] || 0;
                }
            });
        });

        // 5. 更新状态并刷新下拉列表
        this.setState({
            columns: newColumns,
            tableData: dataSource.length === 0 ? [] : newTableData,
            count: dataSource.length
        });
    }

    render() {
        const { 
            gpCalculateLog,
            visible, loading,
            tableData, 
            count, columns,  } = this.state;
        const { 
            basePriceStatus, coefficient, evaluateNum, evaluateFte, evaluateStandardVisitAmount, 
            researchCycle, invNum, planRandomSiteRate, visitRatioFte,
            gpStatus, finalPriceStatus, finalGp } = gpCalculateLog
        return (
            <Modal
                title="GP 测算日志"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                width={1000}
                bodyStyle={{
                    minHeight: 750
                }}
                footer={[
                    <Button key="close" onClick={this.hide}>
                        关闭
                    </Button>
                ]}
            >
                <div className="cont-cont">
                    <ul className="preview-list">
                        <li>
                            <div >建议底价方式：{basePriceStatus === 'VISIT' ? '访视制' : 'FTE制'}</div>
                        </li>
                        <li className="title"><h4>1.评估参数</h4></li>
                        {
                            basePriceStatus === 'VISIT' && (
                                <li>
                                    <div className="item">
                                        <label className="ui-label">难度系数</label>
                                        <span className="" style={{ display: 'flex', alignItems: 'center' }}>
                                            <Tooltip title="难度系数只适用访视评估">
                                                <Icon type="exclamation-circle" style={{ marginRight: 5, color: '#108ee9' }} />
                                            </Tooltip>
                                            {coefficient}
                                        </span>
                                    </div>
                                    <div className="item">
                                        <label className="ui-label">评估例数</label>
                                        <span className="">{evaluateNum}</span>
                                    </div>
                                </li>
                            )
                        }
                        {
                            basePriceStatus === 'VISIT' && (
                                <li>
                                    <div className="item">
                                        <label className="ui-label">评估标访数（*难度）</label>
                                        <span className="">{evaluateStandardVisitAmount}</span>
                                    </div>
                                    <div className="item">
                                        <label className="ui-label">评估FTE数</label>
                                        <span className="">{evaluateFte}</span>
                                    </div>
                                </li>
                            )
                        }
                        {
                            basePriceStatus === 'FTE' && (
                                <li>
                                    <div className="item">
                                        <label className="ui-label">评估例数</label>
                                        <span className="">{evaluateNum}</span>
                                    </div>
                                    <div className="item">
                                        <label className="ui-label">评估FTE数</label>
                                        <span className="">{evaluateFte}</span>
                                    </div>
                                </li>
                            )
                        }
                        <li>
                            <div className="item">
                                <label className="ui-label">研究周期</label>
                                <span className="">{researchCycle} 月</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">参与计算的项目数量</label>
                                <span className="">{invNum}</span>
                            </div>
                        </li>
                        <li>
                            <div className="item">
                                <label className="ui-label">入组数/中心数</label>
                                <span className="">{planRandomSiteRate}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">单位FTE标准访视数</label>
                                <span className="">{visitRatioFte}</span>
                            </div>
                        </li>
                        <li className="title"><h4>2.测算情况</h4></li>
                        <li>
                            <div className="item" style={{display: 'flex', alignItems: 'center', width: '100%'}}>
                                <label className="ui-label">GP测算方式</label>
                                <span className="">
                                    {gpStatus === 'GP' ? '按GP%' : gpStatus === 'PRICE' ? '按总价' : ''}
                                </span>
                            </div>
                        </li>
                        <li>
                            <div style={{ marginBottom: 10 }}></div>
                            <TableC
                                className={count > 0 ? 'calculateTable' : ''}
                                data={tableData}
                                loading={loading}
                                rowKey={'id'}
                                columns={columns}
                                pagination={false}
                                showUnderline={false}
                            />
                        </li>
                        <li className="title"><h4>3.最终GP测算</h4></li>
                        <li>
                            <div className="item" style={{display: 'flex', alignItems: 'center', width: '100%'}}>
                                <label className="ui-label">最终建议报价方式</label>
                                <span className="">
                                    {finalPriceStatus === 'VISIT' ? '访视制' : finalPriceStatus === 'FTE' ? 'FTE制' : ''}
                                </span>
                            </div>
                        </li>
                        <li>
                            <div className="item" style={{display: 'flex', alignItems: 'center', width: '100%'}}>
                                <label className="ui-label">最终GP%</label>
                                <span className="">
                                    {finalGp || ''}%
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

export default GPCalculateLogModal;



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/GPCalculateLogModal.js